var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giga-container"},[_c('giga-left-sidebar'),_c('div',{staticClass:"giga-wrapper"},[_c('giga-header'),_c('div',{class:[_vm.getHasHeaderStatus ? 'has-header' : ''],attrs:{"id":"app-content"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }